export default __webpack_public_path__ + "static/media/screen3.b05e0fce.png";